
    <div *ngIf="file">
       <!-- <button class="download-btn-icon" mat-button (click)="onDownload(file)" onclick="this.blur()" mat-stroked-button
         matTooltip="{{ 'common.cta.download' | translate }}">
         <mat-icon fontSet="fal" fontIcon="fa-file-pdf"></mat-icon>
          {{ 'common.cta.download' | translate }}
        </button> -->
        <a href="{{ file.url }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
          {{ file.originalName }}
        </a>
    </div>
    <div *ngIf="!file">
      Nessun file caricato
    </div>
  